import { Abc } from 'abc2svg/abc2svg-1.js'

class Abc2svgCallbacks {

  constructor() {
    this.abc_svg_output = ""
    this.abc_error_output = ""
    this.img_out = (data) => { this.abc_svg_output += data; }
    this.errmsg = (msg, ln, cn) => { this.abc_error_output += msg + "<br/>\n"; }
    this.read_file = (fn) => ""
    this.anno_start = (music_type, start_offset, stop_offset, x, y, w, h) => {}
    this.anno_stop = (music_type, start_offset, stop_offset, x, y, w, h) => {}
    this.get_abcmodel = (tsfirst, voice_tb, music_types, info) => {}
    this.page_format = true
  }
}

class AbcRenderer {

  constructor() {
    this.abcConfig = '%abc\n' +
                     '%%linewarn 0\n' +
                     //'%%barsperstaff ' + this.props.barsPerLine + '\n' +
                     '%%stretchlast 1\n' +
                     '%%flatbeams 1\n' +
                     '%%maxstaffsep 20px\n' +
                     '%%leftmargin 0cm\n' +
                     '%%rightmargin 0cm\n' +
                     '%%topspace 5px\n' +
                     '%%deco (. 0 dacs 5 1 1 "@-6,-7("\n' +
                     '%%deco ). 0 dacs 5 1 1 "@7,-7)"\n' +
                     '%%beginsvg\n' +
                     ' <defs>\n' +
                     ' <path id="Xhead" d="m-3,-3 l6,6 m0,-6 l-6,6" class="stroke" style="stroke-width:1.2"/>\n' +
                     ' <path id="Trihead" d="m-3,2 l 6,0 l-3,-6 l-3,6 l6,0" class="stroke" style="stroke-width:1.2"/>\n' +
                     ' </defs>\n' +
                     '%%endsvg\n' +
                     '%%map drum ^g heads=Xhead print=g       % Hi-Hat\n' +
                     '%%map drum ^c\' heads=Xhead print=c\'   % Crash\n' +
                     '%%map drum ^d\' heads=Xhead print=d\'   % Stacker\n' +
                     '%%map drum ^A\' heads=Xhead print=A\'   % Ride\n' +
                     '%%map drum ^B\' heads=Trihead print=A\' % Ride Bell\n' +
                     '%%map drum ^D\' heads=Trihead print=g   % Cow Bell\n' +
                     '%%map drum ^c heads=Xhead print=c  % Cross Stick\n' +
                     '%%map drum ^d, heads=Xhead print=d,  % Foot Splash\n'

    this.abcCallbacks = new Abc2svgCallbacks()
  }

  renderAbc = (scale, abcTune, abcSvgDivId, abcErrorDivId) => {

    let abcTarget = document.getElementById(abcSvgDivId),
        errorTarget = document.getElementById(abcErrorDivId)

    abcTune += '%%pagescale ' + scale + '\n' +
               '%%pagewidth ' + abcTarget.offsetWidth + 'px\n' +
               'X:1\n' +
               'M:4/4\n' +
               'L:1/16\n' +
               'K:C clef=perc\n' +
               'V:Snare stem=up\n%%voicemap drum\n' +
               abcTune

    let abc = new Abc(this.abcCallbacks)
    this.abcCallbacks.abc_svg_output = ''
		this.abcCallbacks.abc_error_output = ''
    abc.tosvg('ABC NOTATION', this.abcConfig + abcTune)

    abcTarget.innerHTML = this.abcCallbacks.abc_svg_output
    if (this.abcCallbacks.abc_error_output !== '')
      errorTarget.innerHTML = this.abcCallbacks.abc_error_output
  }

}

export default AbcRenderer


// WEBPACK FOOTER //
// ./src/AbcRenderer.js